/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './withholding_config_model';
import '../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "CreateWithholdingConfigRequest": {
            "fields": {
              "withholdingConfig": {
                "type": ".squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "CreateWithholdingConfigResponse": {
            "fields": {
              "withholdingConfig": {
                "type": ".squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "UpdateWithholdingConfigRequest": {
            "fields": {
              "withholdingConfig": {
                "type": ".squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "UpdateWithholdingConfigResponse": {
            "fields": {
              "withholdingConfig": {
                "type": ".squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ListWithholdingConfigsRequest": {
            "fields": {
              "accountIds": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "includeMostRecentOnly": {
                "type": "bool",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ListWithholdingConfigsResponse": {
            "fields": {
              "withholdingConfigs": {
                "type": ".squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "WithholdingConfigService": {
            "methods": {
              "CreateWithholdingConfig": {
                "requestType": ".squareup.banking.CreateWithholdingConfigRequest",
                "responseType": ".squareup.banking.CreateWithholdingConfigResponse"
              },
              "UpdateWithholdingConfig": {
                "requestType": ".squareup.banking.UpdateWithholdingConfigRequest",
                "responseType": ".squareup.banking.UpdateWithholdingConfigResponse"
              },
              "ListWithholdingConfigs": {
                "requestType": ".squareup.banking.ListWithholdingConfigsRequest",
                "responseType": ".squareup.banking.ListWithholdingConfigsResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.CreateWithholdingConfigRequest && !$root.nested?.squareup?.nested?.banking?.nested?.CreateWithholdingConfigResponse && !$root.nested?.squareup?.nested?.banking?.nested?.UpdateWithholdingConfigRequest && !$root.nested?.squareup?.nested?.banking?.nested?.UpdateWithholdingConfigResponse && !$root.nested?.squareup?.nested?.banking?.nested?.ListWithholdingConfigsRequest && !$root.nested?.squareup?.nested?.banking?.nested?.ListWithholdingConfigsResponse && !$root.nested?.squareup?.nested?.banking?.nested?.WithholdingConfigService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateWithholdingConfigRequest @ squareup/banking/withholding_config_service.proto at 13:1
 */
export const CreateWithholdingConfigRequest = $root.lookupType('squareup.banking.CreateWithholdingConfigRequest');
fixType(CreateWithholdingConfigRequest);
Builder.createAndAttachToType(CreateWithholdingConfigRequest);
/**
 * SOURCE CreateWithholdingConfigResponse @ squareup/banking/withholding_config_service.proto at 17:1
 */
export const CreateWithholdingConfigResponse = $root.lookupType('squareup.banking.CreateWithholdingConfigResponse');
fixType(CreateWithholdingConfigResponse);
Builder.createAndAttachToType(CreateWithholdingConfigResponse);
/**
 * SOURCE UpdateWithholdingConfigRequest @ squareup/banking/withholding_config_service.proto at 22:1
 */
export const UpdateWithholdingConfigRequest = $root.lookupType('squareup.banking.UpdateWithholdingConfigRequest');
fixType(UpdateWithholdingConfigRequest);
Builder.createAndAttachToType(UpdateWithholdingConfigRequest);
/**
 * SOURCE UpdateWithholdingConfigResponse @ squareup/banking/withholding_config_service.proto at 26:1
 */
export const UpdateWithholdingConfigResponse = $root.lookupType('squareup.banking.UpdateWithholdingConfigResponse');
fixType(UpdateWithholdingConfigResponse);
Builder.createAndAttachToType(UpdateWithholdingConfigResponse);
/**
 * SOURCE ListWithholdingConfigsRequest @ squareup/banking/withholding_config_service.proto at 31:1
 */
export const ListWithholdingConfigsRequest = $root.lookupType('squareup.banking.ListWithholdingConfigsRequest');
fixType(ListWithholdingConfigsRequest);
Builder.createAndAttachToType(ListWithholdingConfigsRequest);
/**
 * SOURCE ListWithholdingConfigsResponse @ squareup/banking/withholding_config_service.proto at 40:1
 */
export const ListWithholdingConfigsResponse = $root.lookupType('squareup.banking.ListWithholdingConfigsResponse');
fixType(ListWithholdingConfigsResponse);
Builder.createAndAttachToType(ListWithholdingConfigsResponse);
/**
 * SOURCE WithholdingConfigService @ squareup/banking/withholding_config_service.proto at 45:1
 */
export const WithholdingConfigService = $root.lookupService('squareup.banking.WithholdingConfigService');